{
  "name": "ng-avalon-surveys",
  "version": "2026.1.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "node scripts/version-write.js",
    "build": "npm run prebuild && ng build && npm run sentry:sourcemaps",
    "build:uat": "npm run prebuild && ng build --configuration=uat",
    "build:dev": "npm run prebuild && ng build --configuration=development",
    "watch": "npm run prebuild && ng build --watch --configuration development",
    "test": "ng test",
    "sentry:sourcemaps": "SENTRY_AUTH_TOKEN=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 sentry-cli sourcemaps inject --org avionics --project sal-survey ./dist/ng-avalon-surveys/browser/ && SENTRY_AUTH_TOKEN=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 sentry-cli sourcemaps upload --org avionics --project sal-survey ./dist/ng-avalon-surveys/browser/"
  },
  "private": true,
  "engines": {
    "npm": ">=7.0.0",
    "node": ">=20.19.0"
  },
  "dependencies": {
    "@angular/animations": "21.0.1",
    "@angular/cdk": "21.0.1",
    "@angular/common": "21.0.1",
    "@angular/compiler": "21.0.1",
    "@angular/core": "21.0.1",
    "@angular/forms": "21.0.1",
    "@angular/localize": "^21.0.1",
    "@angular/platform-browser": "21.0.1",
    "@angular/platform-browser-dynamic": "21.0.1",
    "@angular/router": "21.0.1",
    "@angular/service-worker": "21.0.1",
    "@fingerprintjs/fingerprintjs-pro": "^3.12.4",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@sentry/angular": "^10.27.0",
    "@sentry/cli": "^2.58.2",
    "bootstrap": "^5.3.8",
    "crypto-js": "^4.2.0",
    "gsap": "^3.13.0",
    "ng-connection-service": "^13.0.2",
    "ngx-indexed-db": "^21.0.0",
    "ngx-toastr": "^19.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "ua-parser-js": "^2.0.6",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.1",
    "@angular/cli": "21.0.1",
    "@angular/compiler-cli": "21.0.1",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "baseline-browser-mapping": "^2.8.32",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
